module.exports = "<app-header></app-header>\n<app-login></app-login>\n<app-sign-up></app-sign-up>\n<app-forgot-password></app-forgot-password>\n<router-outlet></router-outlet>\n<app-footer></app-footer>\n\n"


//////////////////
// WEBPACK FOOTER
// /Users/muhammadfarhan/Documents/benutech/benutechv2/client/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main